import { NgModule } from '@angular/core';
import bootstrap from 'bootstrap';
import { CommonModule } from '@angular/common';
import { DocDefPrimLibComponent } from './doc-def-prim-lib.component';
import { DodropDownComponent } from './DocDefPrimLib/dodrop-down/dodrop-down.component';
import { DOLabelComponent } from './DocDefPrimLib/dolabel/dolabel.component';
import { DOTextBoxComponent } from './DocDefPrimLib/dotext-box/dotext-box.component';
import { DotextBoxAutocompleteComponent } from './DocDefPrimLib/dotext-box-autocomplete/dotext-box-autocomplete.component';
import { DropdownAutoCompleteComponent } from './DocDefPrimLib/dodropdown-autocomplete/dropdown-autocomplete.component';
import { GridInternalComponent } from './DocDefPrimLib/grid-internal/grid-internal.component';
import { GridNCheckboxComponent } from './DocDefPrimLib/grid-ncheckbox/grid-ncheckbox.component';
import { GridNRadioButtonComponent } from './DocDefPrimLib/grid-nradiobutton/grid-nradiobutton.component';
import { DobuttonComponent } from './DocDefPrimLib/dobutton/dobutton.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SectionTableComponent } from './DocDefPrimLib/section-table/section-table.component';
import { NgDatepickerModule } from 'ng2-datepicker';
import { DoimageComponent } from './DocDefPrimLib/doimage/doimage.component';
import { SectionListComponent } from './DocDefPrimLib/section-list/section-list.component';
import { DocDefPrimLibService } from './doc-def-prim-lib.service';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { DolinkComponent } from './DocDefPrimLib/dolink/dolink.component';
import { SectionAccordionComponent } from './DocDefPrimLib/section-accordion/section-accordion.component';

import { NgbButtonsModule, NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

import { AgGridModule } from 'ag-grid-angular';

import { GridInternalAgGridComponent } from './DocDefPrimLib/grid-internal-ag-grid/grid-internal-ag-grid.component';
import { DoDateNgComponent } from './DocDefPrimLib/do-date-ng/do-date-ng.component';
import { SectionMenuComponent } from './DocDefPrimLib/section-menu/section-menu.component';

import { ModalZipComponent } from './DocDefPrimLib/wrappers/modal-zip/modal-zip.component';
import { MapGoogleMapComponent } from './DocDefPrimLib/map-google-map/map-google-map.component';
import { wrappersService } from './DocDefPrimLib/wrappers/wrappers.service';
import { ModalSearchYouthComponent } from './DocDefPrimLib/wrappers/modal-search-youth/modal-search-youth.component';
import { ModalPlanApprovalComponent } from './DocDefPrimLib/wrappers/modal-plan-approval/modal-plan-approval.component';

import { DiagnosisChildWindowComponent } from './DocDefPrimLib/wrappers/diagnosis-child-window/diagnosis-child-window.component';
import { GenericTextBodyReaderComponent } from './DocDefPrimLib/wrappers/generic-text-body-reader/generic-text-body-reader.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkTreeModule } from '@angular/cdk/tree';

import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DotextBoxSglComponent } from './DocDefPrimLib/dotext-box-sgl/dotext-box-sgl.component';
import { SectionTableDynamicComponent } from './DocDefPrimLib/section-table-dynamic/section-table-dynamic.component';
import { CyTemplateItemComponent } from './DocDefPrimLib/section-table-dynamic/cy-template-item.component';
import { CyTemplateComponent } from './DocDefPrimLib/section-table-dynamic/cy-template.component';
import { CheckboxRendererComponent } from './DocDefPrimLib/rendering/checkbox-cell-rending/checkbox-cell-rending.component';
import { ButtonRendererComponent } from './DocDefPrimLib/rendering/button-cell-rendering/button-cell-rending.component';
import { DropdownRendererComponent } from './DocDefPrimLib/rendering/dropdown-cell-rendering/dropdown-cell-rending.component';
import { DropdownCommentsComponent } from './DocDefPrimLib/dropdown-comments/dropdown-comments.component';
import { GridNCheckboxCommentsComponent } from './DocDefPrimLib/grid-ncheckbox-comments/grid-ncheckbox-comments.component';
import { DocumentUploadComponent } from './DocDefPrimLib/document-upload/document-upload.component';

import { MatButtonModule, MatButton } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatTreeModule } from '@angular/material/tree';
import { MatRippleModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTreeNestedComponent } from './DocDefPrimLib/material-tree/mat-tree-nested/mat-tree-nested.component';
import { ModalCallIdSelectComponent } from './DocDefPrimLib/wrappers/modal-call-id-select/modal-call-id-select.component';
import { GridInternalNoCacheComponent } from './DocDefPrimLib/grid-internal-no-cache/grid-internal-no-cache.component';
import { SectionTableNoCacheComponent } from './DocDefPrimLib/section-table-no-cache/section-table-no-cache.component';
import { DOTextBoxNoCacheComponent } from './DocDefPrimLib/dotext-box-no-cache/dotext-box-no-cache.component';
import { GridInternalAgGridClComponent } from './DocDefPrimLib/grid-internal-ag-grid/grid-internal-ag-grid-cl.component';
import { ModalProgram4UserComponent } from './DocDefPrimLib/wrappers/modal-program4-user/modal-program4-user.component';
import { PreviousAnswerButtonComponent } from './DocDefPrimLib/previous-answer-button/previous-answer-button.component';
import { MatTooltipModule } from '@angular/material';



var AgGrid = require('ag-grid-community');
//require('ag-grid-enterprise');
export * from '../lib/DocDefPrimLib/dotext-box/dotext-box.component';
@NgModule({
    declarations: [DocDefPrimLibComponent, DodropDownComponent, DOLabelComponent, DOTextBoxComponent, DOTextBoxNoCacheComponent
        , DotextBoxAutocompleteComponent, DropdownAutoCompleteComponent, GridInternalComponent
        , GridInternalNoCacheComponent
        , GridNCheckboxComponent, GridNRadioButtonComponent
        , DobuttonComponent, SectionTableComponent
        , SectionTableNoCacheComponent
        , DoimageComponent, SectionListComponent, DolinkComponent
        , SectionAccordionComponent
        , GridInternalAgGridComponent, DoDateNgComponent, SectionMenuComponent, ModalZipComponent, ModalSearchYouthComponent, ModalPlanApprovalComponent, GenericTextBodyReaderComponent, DiagnosisChildWindowComponent
        , MapGoogleMapComponent, DotextBoxSglComponent, SectionTableDynamicComponent, CyTemplateItemComponent, CyTemplateComponent
        , CheckboxRendererComponent, ButtonRendererComponent, DropdownRendererComponent
        , DropdownCommentsComponent, GridNCheckboxCommentsComponent, DocumentUploadComponent
        , MatTreeNestedComponent, ModalCallIdSelectComponent, GridInternalAgGridClComponent
        , ModalProgram4UserComponent, PreviousAnswerButtonComponent
    ],
    imports: [CommonModule, FontAwesomeModule, NgDatepickerModule, FormsModule, NgbDatepickerModule, NgbButtonsModule, NgbModule, PdfViewerModule, DragDropModule, CdkTreeModule, MatButtonModule,
        MatButtonToggleModule, MatIconModule, MatTooltipModule, MatButtonModule, MatTreeModule, MatRippleModule, MatInputModule, MatSelectModule, MatCheckboxModule, MatMenuModule, MatCardModule, MatProgressBarModule
        , AgGridModule.withComponents([CheckboxRendererComponent, ButtonRendererComponent, DropdownRendererComponent])
    ], entryComponents: [
        DodropDownComponent, DOLabelComponent, DOTextBoxComponent, DOTextBoxNoCacheComponent, DotextBoxSglComponent,
        DotextBoxAutocompleteComponent, GridInternalComponent
        , GridInternalNoCacheComponent
        , GridNCheckboxComponent, GridNRadioButtonComponent,
        DobuttonComponent, PreviousAnswerButtonComponent, SectionTableComponent
        , SectionTableNoCacheComponent
        , DoimageComponent, DolinkComponent, DropdownAutoCompleteComponent,
        GridInternalAgGridComponent, DoDateNgComponent, GenericTextBodyReaderComponent, DiagnosisChildWindowComponent,
        ModalZipComponent, ModalCallIdSelectComponent, MapGoogleMapComponent, ModalSearchYouthComponent
        , ModalPlanApprovalComponent, DocumentUploadComponent, MatTreeNestedComponent, ModalProgram4UserComponent
    ],
    exports: [DocDefPrimLibComponent,
        SectionTableComponent,
        SectionTableNoCacheComponent,
        SectionTableDynamicComponent,
        SectionListComponent,
        SectionAccordionComponent,
        SectionMenuComponent,
        GridInternalComponent
        , GridInternalNoCacheComponent
        , GridInternalAgGridComponent
        , DOTextBoxComponent
        , DOTextBoxNoCacheComponent
        , DobuttonComponent
        , DocumentUploadComponent
        , MatTreeNestedComponent
        , DoDateNgComponent
        , GridNCheckboxComponent
        , DodropDownComponent
        , PreviousAnswerButtonComponent]
})
export class DocDefPrimLibModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: DocDefPrimLibModule,
            providers: [DocDefPrimLibService, wrappersService]
        };
    }
}
